export enum SortDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}
